
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novos",
      function () {
        return require("private-next-pages/novos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novos"])
      });
    }
  